export default class ModalTermsConditionsController {
  /* @ngInject */
  constructor(close, user) {
    this.close = close;
    this.user = user;
    this.title = 'Terms & Conditions';
    this.conditions = [{
      title: 'Terms and Conditions',
      file: '/assets/doc/termsAndConditions.pdf',
      isFileOpened: false,
      isAccepted: false,
    }, {
      title: 'Attachment to T&C',
      file: '/assets/doc/privacy.pdf',
      isFileOpened: false,
      isAccepted: false,
    }];
  }

  openFile(condition) {
    window.open(condition.file, '_blank');
    condition.isFileOpened = true;
  }

  allConditionsAreAccepted() {
    return this.conditions.every(condition => condition.isAccepted);
  }

  changeCondition() {
    const allConditionsAreAccepted = this.allConditionsAreAccepted();
    if (allConditionsAreAccepted) {
      this.close({
        conditions: Object.assign({}, this.conditions),
        conditionsAccepted: allConditionsAreAccepted,
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/modal/modal-terms-conditions/modal-terms-conditions.controller.js